import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { forkJoin, map, switchMap } from 'rxjs';
import { ChopAlterskategorie, ChopKatalog, ChopLeistungsgruppe, ChopProfil } from '@entity/chop';
import { ChopService } from '@service/chop.service';

export interface ChopLeistungsgruppeDetailData {
  leistungsgruppe: ChopLeistungsgruppe;
  alterskategorie: ChopAlterskategorie;
  katalog: ChopKatalog;
  profile: ChopProfil[];
}

export const ChopLeistungsgruppeDetailResolve: ResolveFn<ChopLeistungsgruppeDetailData> = (route) => {
  const chopService = inject(ChopService);
  return chopService.getLeistungsgruppe(+route.params.leistungsgruppeId).pipe(
    switchMap((leistungsgruppe) =>
      forkJoin({
        alterskategorie: chopService.getAlterskategorie(leistungsgruppe.chopAlterskategorieId),
        profile: chopService.getProfile(leistungsgruppe.id),
      }).pipe(
        switchMap((rest) =>
          chopService
            .getKatalog(rest.alterskategorie.chopKatalogId)
            .pipe(map((katalog) => ({ leistungsgruppe, ...rest, katalog })))
        )
      )
    )
  );
};
